import { Avatar, Flex, List, Typography } from "antd";
import { ExperienceInterface } from "api/enumerator/Profile/dto";
import dayjs from "dayjs";
import { formatDate } from "utils/date";

const { Text } = Typography;

interface ExperienceItemProps {
  item: ExperienceInterface;
}

export const ExperienceItem = ({ item }: ExperienceItemProps) => (
  <List.Item>
    <List.Item.Meta
      avatar={
        <Avatar size={50} style={{ backgroundColor: "#22AD5C" }}>
          {item?.company[0]?.toUpperCase()}
        </Avatar>
      }
      title={<span style={{fontSize: '1.25rem', fontWeight: 'bold'}} >{item?.company}</span>}
      description={
        <Flex vertical>
          <Text type="secondary">{item?.title}</Text>
          <Text type="secondary">
            {item.startDate && formatDate(dayjs(item?.startDate.toDate()))} -{" "}
            {item?.endDate && formatDate(dayjs(item?.endDate.toDate()))}
          </Text>
          <Flex vertical>
            {item?.location}
          </Flex>
        </Flex>
      }
    />

  </List.Item>
);